// utils/web3.js — IDENTIDADE PRIMEIRO, RUA DEPOIS
// Polygon Mainnet + RUA Token + WalletConnect Ready
import { ethers } from 'ethers';

const RUA_ABI = [
  "function balanceOf(address) view returns (uint256)",
  "function submitLiveProof(bytes32 videoHash) public",
  "function usedProofs(bytes32) view returns (bool)"
];

const CONTRACT_ADDRESS = "0xb0a71252b91ce1471e992833f0ba9ca83f905dd7";
const RPC_URL = "https://polygon-rpc.com"; // User preferred
const FALLBACK_RPC_URL = "https://1rpc.io/matic"; // High-limit privacy RPC
const ANKR_RPC_URL = "https://rpc.ankr.com/polygon";
const CHAIN_ID = 137;

let provider, signer, contract, userAddress, currentChainId;

export const connectWallet = async () => {
  console.log("PRUMO 1: INICIANDO CONEXÃO COM CARTEIRA...");

  if (!window.ethereum) {
    console.error("MetaMask ou WalletConnect não detectado");
    alert("Carteira não detectada! Use MetaMask, Coinbase, ou WalletConnect.");
    throw new Error("Carteira não detectada");
  }

  try {
    console.log("Tentando mudar para Polygon Mainnet...");
    await window.ethereum.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: '0x89' }],
    });
    currentChainId = CHAIN_ID;
    console.log("Rede: Polygon Mainnet (137)");
  } catch (switchError) {
    if (switchError.code === 4902) {
      console.log("Adicionando Polygon Mainnet...");
      await window.ethereum.request({
        method: 'wallet_addEthereumChain',
        params: [{
          chainId: '0x89',
          chainName: 'Polygon Mainnet',
          nativeCurrency: { name: 'MATIC', symbol: 'MATIC', decimals: 18 },
          rpcUrls: [RPC_URL, FALLBACK_RPC_URL, ANKR_RPC_URL],
          blockExplorerUrls: ['https://polygonscan.com'],
        }],
      });
      currentChainId = CHAIN_ID;
    } else {
      console.warn("Usuário não mudou de rede. Continuando em:", switchError.message);
      const chainIdHex = await window.ethereum.request({ method: 'eth_chainId' });
      currentChainId = parseInt(chainIdHex, 16);
      console.log(`Rede atual: ${currentChainId}`);
    }
  }

  try {
    await window.ethereum.request({ method: 'eth_requestAccounts' });
    console.log("Acesso concedido");
  } catch (err) {
    console.error("Usuário rejeitou conexão", err);
    throw new Error("Conexão rejeitada");
  }

  provider = new ethers.BrowserProvider(window.ethereum);
  signer = await provider.getSigner();
  userAddress = await signer.getAddress();

  // Só conecta ao contrato se estiver na Polygon
  if (currentChainId === CHAIN_ID) {
    contract = new ethers.Contract(CONTRACT_ADDRESS, RUA_ABI, signer);
    console.log("Contrato RUA conectado:", CONTRACT_ADDRESS);
  } else {
    contract = null;
    console.warn("Não está na Polygon → RUA desativado (opcional)");
  }

  // Saldo RUA (opcional)
  let ruaBalance = null;
  if (contract) {
    try {
      const balanceRaw = await contract.balanceOf(userAddress);
      ruaBalance = ethers.formatEther(balanceRaw);
      console.log(`SALDO RUA: ${ruaBalance} RUA`);
    } catch (e) {
      console.warn("Saldo RUA indisponível (opcional)", e.message);
    }
  }

  console.log("CONECTADO:", { address: userAddress, chainId: currentChainId, ruaBalance });
  return { address: userAddress, chainId: currentChainId, ruaBalance };
};

export const getRuaBalance = async (addr) => {
  if (!contract) {
    console.log("Contrato não disponível (não está na Polygon)");
    return null;
  }
  try {
    const balance = await contract.balanceOf(addr || userAddress);
    return ethers.formatEther(balance);
  } catch (err) {
    console.warn("Falha ao ler saldo RUA:", err.message);
    return null;
  }
};

export const submitProof = async (clipBase64) => {
  console.log("PRUMO 2: ENVIANDO PROVA PARA BLOCKCHAIN...");

  if (!clipBase64) throw new Error("Clip não fornecido");
  if (!contract) {
    console.warn("Não conectado à Polygon → Prova apenas no backend");
    throw new Error("Rede não é Polygon");
  }

  try {
    const videoBytes = ethers.getBytes(clipBase64.split(',')[1]);
    const videoHash = ethers.keccak256(videoBytes);
    console.log("Hash do vídeo (32 bytes):", videoHash);

    const alreadyUsed = await contract.usedProofs(videoHash);
    if (alreadyUsed) {
      console.warn("Prova já usada na blockchain");
      throw new Error("Prova já registrada");
    }

    const tx = await contract.submitLiveProof(videoHash);
    console.log("Transação enviada. Aguardando...");
    const receipt = await tx.wait();

    console.log("PRUMO 3: PROVA REGISTRADA! TX:", receipt.hash);
    return { txHash: receipt.hash, ruaEarned: true };
  } catch (err) {
    console.warn("PROOF FALHOU (opcional):", err.message);
    throw err;
  }
};

// === UTILS ===
export const isPolygonConnected = () => currentChainId === CHAIN_ID;
export const getCurrentChainId = () => currentChainId;
export const getUserAddress = () => userAddress;
